import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderInner from "./HeaderInner";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import configureStore from "../../../store/configureStore";
import Footer from "./Footer";
import Loader from "../../common/Loader";
import { Avatar } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { history } from "../../../reducers";
import { Link } from "react-router-dom";
import { get_task_details } from "./actions/action-task";

const store = configureStore();

const useStyles = makeStyles((theme) => ({
  avatar: {
    textTransform: "uppercase",
  },
}));

function TaskDetails() {
  const classes = useStyles();
  const { activeOuid } = store.getState().permission;
  const dispatch = useDispatch();
  const { taskDetails, showGlobalLoader } = useSelector((state) => state.task);

  let taskId;
  taskId = window.location.pathname.split("/");
  taskId = taskId[3];

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_task_details(taskId, activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Task Details " />
      <div className="HrmAppPage container--narrow mt">
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <div className="notes_details_wrap">
            <div className="profile_top">
              <div className="profile_left">
                <div className="profile_img">
                  <Avatar
                    className={classes.avatar}
                    style={{
                      backgroundColor: "#214B87",
                    }}
                  >
                    {taskDetails.leadContactFullName &&
                      taskDetails.leadContactFullName.charAt(0)}
                  </Avatar>
                </div>
                <div className="profile_details">
                  <Link
                    to={`/${activeOuid}/contact-profile/${taskDetails.leadId}`}
                    className="profile_name"
                  >
                    {taskDetails.leadContactFullName}
                  </Link>
                  {/* <div className="profile_company_name">shadi.com</div> */}
                </div>
              </div>

              <div className="profile_right"></div>
            </div>
            <p className="note_detail_desc mt">{taskDetails.taskDetail}</p>
            <div className="note_details_bottom">
              <Link to={`/${activeOuid}/edit-task/${taskDetails.id}`}>
                <BorderColorIcon />
              </Link>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
}

export default TaskDetails;
